module.exports = "#banner\r\n{\r\n  padding-top:40px;\r\n}\r\n"